import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { leaves, routes } from "~/constants";
import {
  OnboardingLayout,
  PartnerRedirector,
} from "~/OnboardingApp/components";
import { ActivatePartnerPage } from "~/OnboardingApp/pages/ActivatePartnerPage";
import { ThanksForSharingPage } from "~/OnboardingApp/pages/interstitialPages/ThanksForSharingPage";
import { BirthdayPage } from "~/OnboardingApp/pages/questionPages/BirthdayPage";
import { ClinicSatisfactionPage } from "~/OnboardingApp/pages/questionPages/ClinicSatisfactionPage";
import { DueDatePage } from "~/OnboardingApp/pages/questionPages/DueDatePage";
import { EmailPage } from "~/OnboardingApp/pages/questionPages/EmailPage";
import { HowLongPage } from "~/OnboardingApp/pages/questionPages/HowLongPage";
import { JourneyLooksLikePage } from "~/OnboardingApp/pages/questionPages/JourneyLooksLikePage";
import { MostChallengingPage } from "~/OnboardingApp/pages/questionPages/MostChallengingPage";
import { NextMilestonePage } from "~/OnboardingApp/pages/questionPages/NextMilestonePage";
import { PartnerPage } from "~/OnboardingApp/pages/questionPages/PartnerPage";
import { PhonePage } from "~/OnboardingApp/pages/questionPages/PhonePage";
import { ProviderSelectPage } from "~/OnboardingApp/pages/questionPages/ProviderSelectPage";
import { ProvidersSeenPage } from "~/OnboardingApp/pages/questionPages/ProvidersSeenPage";
import { SupportNeedsPage } from "~/OnboardingApp/pages/questionPages/SupportNeedsPage";
import { WelcomeNamePage } from "~/OnboardingApp/pages/questionPages/WelcomeNamePage";
import { Protector } from "./Protector";
import { rrPath } from "./utils";

export const PartnerOnboardingRoutes: FC = () => {
  return (
    <Routes>
      <Route index element={<Navigate replace={true} to={routes.root} />} />

      <Route path={rrPath(leaves.slug)} element={<PartnerRedirector />}>
        <Route index element={<Navigate replace={true} to={routes.root} />} />
        <Route
          path={rrPath(leaves.activate)}
          element={
            <Protector requireAuth requireOnboarding protectPayment>
              <ActivatePartnerPage />
            </Protector>
          }
        />
        <Route
          path={rrPath(leaves.onboardingRoot)}
          element={<OnboardingLayout />}
        >
          <Route index element={<Navigate replace={true} to={routes.root} />} />
          <Route
            path={rrPath(leaves.questionName)}
            element={<WelcomeNamePage />}
          />
          <Route
            path={rrPath(leaves.questionHowLong)}
            element={<HowLongPage />}
          />
          <Route path={rrPath(leaves.questionEmail)} element={<EmailPage />} />
          <Route
            path={rrPath(leaves.questionDueDate)}
            element={<DueDatePage />}
          />
          <Route
            path={rrPath(leaves.questionProvidersSeen)}
            element={<ProvidersSeenPage />}
          />
          <Route
            path={rrPath(leaves.questionProviderSelect)}
            element={<ProviderSelectPage />}
          />
          <Route
            path={rrPath(leaves.questionJourneyLooksLike)}
            element={<JourneyLooksLikePage />}
          />
          <Route
            path={rrPath(leaves.questionNextMilestone)}
            element={<NextMilestonePage />}
          />
          <Route
            path={rrPath(leaves.questionSupportNeeds)}
            element={<SupportNeedsPage />}
          />
          <Route
            path={rrPath(leaves.questionMostChallenging)}
            element={<MostChallengingPage />}
          />
          <Route
            path={rrPath(leaves.questionClinicSatisfaction)}
            element={<ClinicSatisfactionPage />}
          />
          <Route
            path={rrPath(leaves.questionPartner)}
            element={<PartnerPage />}
          />
          <Route
            path={rrPath(leaves.questionBirthday)}
            element={<BirthdayPage />}
          />
          <Route path={rrPath(leaves.questionPhone)} element={<PhonePage />} />
          <Route
            path={rrPath(leaves.interstitialThanksForSharing)}
            element={<ThanksForSharingPage />}
          />
        </Route>
      </Route>
    </Routes>
  );
};
